var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyLayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 546,
    viewBox: "0 0 545 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M367.531 467.47L356.274 453.157L306.281 389.566L245.032 467.47H367.531Z",
    fill: "#00CC8F"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M545 406.08H448.473L448.466 406.087L496.726 467.471H496.74L545 406.087V406.08Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.769 389.56L245.018 467.464H245.032L306.281 389.56L306.274 389.553H183.775L183.769 389.56Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M367.515 468.282L427.737 544.875H307.297L367.515 468.282Z",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2632 233.725L61.2563 233.732L122.506 311.636H122.519L183.769 233.732L183.762 233.725H61.2632Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 311.636L183.769 233.732L122.52 311.636H245.018Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 311.649L183.762 389.553H183.776L245.025 311.649L245.018 311.636H122.52L122.513 311.649Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.769 77.9106L122.513 155.815H245.018L183.769 77.9106Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M122.506 155.814H122.513L183.769 77.9106L183.762 77.9038H61.2563V77.9106L122.506 155.814Z",
    fill: "black",
    fillOpacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 0L61.2563 77.9039H183.762L122.513 0Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 466.664L62.2802 390.053H182.745L122.513 466.664Z",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.506 311.643H0.00684357L0 311.649L61.2494 389.553H61.2631H183.762L122.513 311.649L122.506 311.643Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4923 233.225L1.02384 156.314H122.264L182.733 233.225H61.4923Z",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M306.268 545.375H306.275H306.268L245.025 467.471L183.776 545.375H306.254H306.268Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 155.814H245.025L306.281 77.9106L306.274 77.9038H183.769V77.9106L245.018 155.814Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M428.794 390.368L489.014 466.963H368.573L385.035 446.016L385.035 446.015L428.794 390.368Z",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M367.617 466.562L367.534 466.668L384.642 445.707L367.867 467.054L367.617 466.562ZM367.617 466.562L384.249 445.398L384.619 445.689L384.249 445.398L428.157 389.561L367.538 312.458L306.918 389.561L356.667 452.842L367.523 466.654L367.608 466.546L367.617 466.562ZM246.049 467.964H366.493L306.268 544.566L246.049 467.964ZM183.769 390.369L244.388 467.472L183.533 544.875H62.2923L122.761 467.964H122.762L122.913 467.773L183.769 390.369Z",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 388.753L246.043 312.136H366.519L306.281 388.753Z",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M183.762 389.553L183.769 389.56L183.775 389.553H183.762Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.399 221.341L352.652 195.582L372.911 221.341H332.399Z",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M236.66 60.8702L269.052 19.6708L301.445 60.8702H236.66Z",
    stroke: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 77.9038H306.274L306.281 77.9102V77.9038Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M490.05 467.471L490.057 467.464H490.043L490.05 467.471Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M428.801 389.553H428.787L428.794 389.56L428.801 389.553Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M183.768 77.9038H183.762L183.768 77.9102V77.9038Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M367.544 311.636H367.531L367.538 311.649L367.544 311.636Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.792 234.225H305.257L245.025 310.835L184.792 234.225Z",
    stroke: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M243.989 156.314L183.762 232.916L123.537 156.314H243.989Z",
    stroke: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 155.814L183.762 233.725H306.302L245.018 155.814Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M183.742 545.381H183.755L244.998 467.491L244.991 467.477L244.998 467.471H122.499L122.492 467.477L183.742 545.381Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 545.381H306.302L367.537 467.491L367.531 467.477L367.537 467.471H245.045L245.039 467.477L306.281 545.381Z",
    fill: "black",
    fillOpacity: 0.14
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 155.814L306.288 77.9308L306.275 77.9173L306.282 77.9038H183.79L183.783 77.9173L245.018 155.814Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M122.205 311.791H122.218L183.461 233.901L183.454 233.887L183.461 233.874H60.9619L60.9551 233.887L122.205 311.791Z",
    fill: "#00CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M428.766 389.546L417.509 375.233L367.517 311.643L306.268 389.546H428.766Z",
    fill: "#00CC8F"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M411.689 411.31L428.794 389.553H306.295L367.544 467.457L411.689 411.31Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M325.132 225.121L288.362 271.888V271.894H288.369H361.902L325.132 225.121Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 467.423L184.084 545.3H122.855V467.423Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLayer);
export default __webpack_public_path__ + "static/media/companyLayer.8b67ec97e87d46ba646b8bdcc4a27c3f.svg";
export { ForwardRef as ReactComponent };